import { RecordBase, registerInflection } from  'lib/record-base';
import { User } from 'lib/user';

export class WeightRecord extends RecordBase {
    static NAME = 'WeightRecord'

    unitWeight(unitPreference) {
        if(unitPreference === User.METRIC) {
            return this.weight/2.2;
        } else {
            return this.weight;
        }
    }
}

registerInflection('weightRecord','weightRecords',WeightRecord);